// assets/nd-cart-shipping-reset.js
// Neuma Cart – Reset quote/shipping attributes and note when user clears the cart (v8)

(function () {
  if (window.__ND_CART_SHIPPING_RESET_V8__) return;
  window.__ND_CART_SHIPPING_RESET_V8__ = true;
  console.info('[ND Cart] shipping reset v8 loaded');

  function clearLocalShippingCache() {
    try {
      if (!window.localStorage) return;
      Object.keys(localStorage).forEach(function (k) {
        var key = k.toLowerCase();
        // 只清我們自己用的 key，不亂動別的 app
        if (
          key.indexOf('nd_shipping') !== -1 ||
          key.indexOf('nd-cart-shipping') !== -1 ||
          key.indexOf('nd_factor') !== -1 ||
          key.indexOf('nd_cart_factor') !== -1 ||
          key.indexOf('nd_special_instruction') !== -1 ||
          key.indexOf('nd_quote_shipping') !== -1
        ) {
          localStorage.removeItem(k);
        }
      });

      // 有些會放在 sessionStorage，一起順便清
      try {
        Object.keys(sessionStorage).forEach(function (k) {
          var key = k.toLowerCase();
          if (
            key.indexOf('nd_shipping') !== -1 ||
            key.indexOf('nd-cart-shipping') !== -1 ||
            key.indexOf('nd_factor') !== -1 ||
            key.indexOf('nd_cart_factor') !== -1 ||
            key.indexOf('nd_special_instruction') !== -1 ||
            key.indexOf('nd_quote_shipping') !== -1
          ) {
            sessionStorage.removeItem(k);
          }
        });
      } catch (e) {}

      console.info('[ND Cart] local shipping/factor cache cleared');
    } catch (e) {
      console.warn('[ND Cart] failed to clear local shipping cache', e);
    }
  }

  function clearCartShippingAttributes() {
    try {
      var attrs = {
        // ------ 舊版命名（字首大寫） ------
        // Quote / reference
        reference: '',
        'Quote ID': '',
        'Reference #': '',
        'Reference Number': '',

        // Factor / note
        Factor: '',
        'Special Instruction': '',

        // Contact / company / address
        'Contact Name': '',
        'Contact Phone': '',
        'Phone Number': '',
        Company: '',
        'Company Name': '',
        Address: '',
        'Shipping Address': '',
        'Shipping Contact Name': '',
        'Shipping Phone': '',

        // ------ 新版命名（全小寫 / 底線） ------
        factor: '',
        special_instruction: '',
        contact_name: '',
        phone_number: '',
        reference_numb: '',
        company_name: '',
        shipping_address: ''
      };

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: attrs,
          // IMPORTANT: also clear Shopify built-in cart note
          note: ''
        })
      })
        .then(function () {
          console.info('[ND Cart] cart quote/shipping attributes and note cleared');
        })
        .catch(function (e) {
          console.warn('[ND Cart] failed to clear cart attributes/note', e);
        });
    } catch (e) {
      console.warn('[ND Cart] exception when clearing cart attributes/note', e);
    }
  }

  // 也順便把畫面上看得到的欄位清掉
  function clearCartDomFields() {
    try {
      // Factor input
      var factorEl = document.querySelector('#nd-factor-input');
      if (factorEl) {
        factorEl.value = '';
        factorEl.dispatchEvent(new Event('input', { bubbles: true }));
        factorEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Special Instruction textarea (cart note)
      var noteEl =
        document.querySelector('#Cart-note') ||
        document.querySelector('textarea[name="note"]');
      if (noteEl) {
        noteEl.value = '';
        noteEl.dispatchEvent(new Event('input', { bubbles: true }));
        noteEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Company input (shipping company)
      var companyEl = document.querySelector(
        'input[name="attributes[Company Name]"], input[name="attributes[Company]"], input[name="attributes[company_name]"]'
      );
      if (companyEl) {
        companyEl.value = '';
        companyEl.dispatchEvent(new Event('input', { bubbles: true }));
        companyEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      console.info('[ND Cart] cart DOM factor/note/company fields cleared');
    } catch (e) {
      console.warn('[ND Cart] failed to clear DOM fields', e);
    }
  }

  function hardResetShipping() {
    console.info('[ND Cart] hard reset triggered');
    clearLocalShippingCache();
    clearCartShippingAttributes();
    clearCartDomFields();
  }

  // 讓其他腳本（或你在 Console）可以呼叫這個重置
  window.__ND_DEBUG_RESET_CART_ATTRS = hardResetShipping;

  var path = (window.location.pathname || '').toLowerCase();

  // 1) 在 cart 頁面掛 Clear Cart 按鈕
  if (path.indexOf('/cart') !== -1) {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest('button, a');
      if (!t) return;

      var txt = (t.textContent || '').trim().toLowerCase();
      var isClear =
        t.hasAttribute('data-nd-clear-cart') ||
        txt === 'clear cart' ||
        txt === 'empty cart' ||
        txt.indexOf('clear cart') !== -1;

      if (!isClear) return;

      console.info('[ND Cart] Clear Cart click detected → reset quote/shipping');
      // 等主題/APP 清完商品後，再清屬性
      setTimeout(hardResetShipping, 300);
    });
  }

  // 2) 在 quotation-detail / quote 頁，只清本地快取（避免載回舊的 shipping 資料）
  if (
    path.indexOf('quotation-detail') !== -1 ||
    (path.indexOf('quote') !== -1 && path.indexOf('/cart') === -1)
  ) {
    clearLocalShippingCache();
  }
})();
